import { render, staticRenderFns } from "./contentView.vue?vue&type=template&id=5a5dcc96&scoped=true"
import script from "./contentView.vue?vue&type=script&lang=js"
export * from "./contentView.vue?vue&type=script&lang=js"
import style0 from "./contentView.vue?vue&type=style&index=0&id=5a5dcc96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5dcc96",
  null
  
)

export default component.exports